import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
// @ts-ignore
import { makeSelectDocumentSetExists } from 'services/documentSets/selectors';

interface OwnProps {
    documentSetId: number;
    fallbackComponent?: React.ReactNode;
    children: React.ReactNode;
}

interface ConnectedProps {
    documentSetExists?: boolean;
}

type Props = OwnProps & ConnectedProps;

export class DocumentSetExistsGate extends React.PureComponent<Props> {
    render(): React.ReactNode | null {
        const { documentSetExists, children, fallbackComponent } = this.props;
        if (!documentSetExists) {
            return fallbackComponent || null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    documentSetExists: makeSelectDocumentSetExists()
});

export default connect(mapStateToProps)(DocumentSetExistsGate);
